<template>
    <div class="icon-candidate animated zoomIn">
        <span class="name-candidate" v-if="index != 0">{{ name }}</span>
        <img :style="widthCalc" :src="image" alt="" class="img-candidate">
    </div>
</template>
<script>
export default {
    props: {
        
        width : {
            type : Number,
            required: false
        },
        name : {
            type : String
        },
        index : {
            type : Number
        },
        color : {
            type : String
        }
    },
    computed: {
        widthCalc(){
            return {
                'width' : this.width + 'px'
            }
        },
        image(){
            switch(this.color){
                case '#009DFF':
                    return require(`../../assets/candidate-blue.png`)
                case '#9edac2':
                    return require(`../../assets/candidate-green.png`)
                case '#FF9800':
                    return require(`../../assets/candidate-orange.png`)
                case '#873AD8':
                    return require(`../../assets/candidate-purple.png`)
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .icon-candidate{

        display: flex;
        align-items: center;
        flex-direction: column;

        .name-candidate{

            width: 90px;
            text-align: center;
            margin-bottom: 10px;
            text-transform: uppercase;
            font-size: 9px;
            letter-spacing: 1px;
        }
    }
</style>
